/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { useMutation } from "@apollo/client";
import { Card } from "@material-ui/core";
import { useFormik } from "formik";

import { AlertMessage } from "../../../Components/AlertMessage";
import SideBar from "../../../Components/Sidebar/SideBar";
import * as auth from "../_redux/authRedux";
import { SET_PASSWORD } from "../mutations";

import { useSetPasswordValidationSchema } from "./useSetPasswordValidationSchema";

function SetPassword(props) {
  const { initialValues, setPasswordValidationSchema } = useSetPasswordValidationSchema();

  const [loading, setLoading] = useState(false);

  const [isRedirect, setRedirectLogin] = useState(false);

  const [emailToken, setEmailToken] = useState("");

  const [state, setState] = useState({
    open: false,
    message: "Password successfully set!",
    severity: "success",
  });

  const handleSnackbarClose = () => {
    setState({ ...state, open: false });
  };

  const [
    setPassword,
    { loading: pwdLoading, error: pwdError, data: pwdData },
  ] = useMutation(SET_PASSWORD);

  useEffect(() => {
    setEmailToken(props?.match?.params?.id);
  }, []);

  useEffect(() => {
    if (pwdLoading) {
      setLoading(true);
    }

    if (pwdError) {
      formik.setStatus(pwdError.toString().replace("Error: Error:", ""));
      setLoading(false);
    }

    if (pwdData) {
      setState({ ...state, open: true });
      setRedirectLogin(true);
    }
  }, [pwdLoading, pwdError, pwdData]);

  const getInputClasses = fieldname => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: setPasswordValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setLoading(true);
      setPassword({
        variables: {
          emailToken,
          password: values.password,
        },
      });
      setSubmitting(false);
    },
  });

  return (
    <SideBar>
      <div
        className="login-form login-signin"
        id="set-password"
        style={{ display: "block" }}
      >
        <AlertMessage
          message={state.message}
          severity={state.severity}
          handleClose={handleSnackbarClose}
          open={state.open}
        />
        {isRedirect && <Redirect to="/" />}
        <div className="text-center">
          <h1 style={{ fontWeight: "bold", fontSize: "3rem" }}>
            <FormattedMessage id="AUTH.REGISTER.TITLE" />
          </h1>
        </div>
        <Card className="px-5 py-5">
          <h5 className="text-center">Set your Password</h5>
          <form
            id="kt_login_signin_form"
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp mt-5"
            onSubmit={formik.handleSubmit}
          >
            {/* Begin: Alert */}
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            {/* End: Alert */}

            {/* Begin: Password */}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Password"
                type="password"
                className={`form-control form-control-solid h-auto ${getInputClasses(
                  "password",
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {(formik.touched.password && formik.errors.password) && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              )}
            </div>
            {/* End: Password */}

            {/* Begin: Confirm Password */}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Confirm Password"
                type="password"
                className={`form-control form-control-solid h-auto ${getInputClasses(
                  "confirmpassword",
                )}`}
                name="confirmpassword"
                {...formik.getFieldProps("confirmpassword")}
              />
              {(formik.touched.confirmpassword &&
              formik.errors.confirmpassword) && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.confirmpassword}
                  </div>
                </div>
              )}
            </div>
            {/* End: Confirm Password */}

            <div className="d-flex flex-wrap justify-content-center align-items-center">
              <button
                id="kt_login_signin_submit"
                type="submit"
                disabled={formik.isSubmitting}
                className={
                  "btn btn-outline-secondary bg-white w-100 font-weight-bold px-9 py-4"
                }
              >
                <span>Submit</span>
                {loading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            </div>
          </form>
        </Card>
      </div>
    </SideBar>
  );
}

export default injectIntl(connect(null, auth.actions)(SetPassword));
